import { render, staticRenderFns } from "./ReceptorClientes.vue?vue&type=template&id=9eff04b8&"
import script from "./ReceptorClientes.vue?vue&type=script&lang=js&"
export * from "./ReceptorClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports